import Confirm from "./Confirm";

import General from "./General";

export default {
  GENERAL: General,
  CONFIRM: Confirm,
};
